import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AccountSetupComponent } from './account-setup.component';
import { AccountSetupRoutingModule } from './account-setup-routing.module';

import { SharedModule } from 'shared/shared.module';


@NgModule({
  imports: [
      CommonModule,
      RouterModule,
      AccountSetupRoutingModule,
      SharedModule,
  ],
  declarations: [AccountSetupComponent],
  exports: [AccountSetupComponent]
})
export class AccountSetupModule {}
